import { Grid2,Box, Typography } from "@mui/material"
import background  from "../../../ui-utils/photos/bgvideo.mp4"
import LeaderWebViewStyles from "./LeaderMobileView.module.css"
import Narayana from "../../../ui-utils/latestPics/Narayana.png"
import Roshni from "../../../ui-utils/latestPics/Roshni.svg"
import Manaorama from "../../../ui-utils/latestPics/Manaorama.svg"
import en from "../../../i18n/English/Aboutus/founders.json";
import hi from "../../../i18n/Hindi/Aboutus/founders.json";
import kn from "../../../i18n/Kannada/Aboutus/founders.json";
import gu from "../../../i18n/Gujarati/Aboutus/founders.json";
import ma from "../../../i18n/Marathi/Aboutus/founders.json";
import { useLanguage } from "../../../Context/LangContext";
import { useState,useEffect,useRef } from "react"
export default function MobileView(){

        const [isFlipped, setIsFlipped] = useState(false);
    const [isFlipped2, setIsFlipped2] = useState(false);
    const [isFlipped3, setIsFlipped3] = useState(false);
     const backRef = useRef(null);
    const { language } = useLanguage();
    const translations = { en, hi, kn, gu, ma };
    const t = translations[language] || translations.en;

    useEffect(() => {
        if (isFlipped && backRef.current) {
            backRef.current.scrollTop = 0;
        }
    }, [isFlipped]);

        const handleTouchFlip = () => {
            setIsFlipped((prev) => !prev);
        };
    return (
        <>
      <Box className={LeaderWebViewStyles.HomeSectionBox}>

        <Grid2 sx={{  width: "100%" }}>

                    {/* <h1 className={LeaderWebViewStyles.leader_title}>{t.heading}</h1> */}
                    <div className={LeaderWebViewStyles.headingContainer}>
                        <div className={LeaderWebViewStyles.gradientBackground}></div>
                        <Typography className={LeaderWebViewStyles.leader_title} style={{ fontWeight: 600 }}>
                            {t.heading}
                        </Typography>
                    </div>

                            <Grid2 className={LeaderWebViewStyles.inner_card}>
                                {/* <Grid2  className={LeaderWebViewStyles.leader_card1}>

                                    <Typography className={LeaderWebViewStyles.ex_subtit}>Mr. Narayana B. Shetty</Typography>
                                    <Typography className={LeaderWebViewStyles.ex_subtit1}>MD &amp; Chiarman</Typography>
                                    <Typography className={LeaderWebViewStyles.ex_subtit2}>Mr. Shetty is a seasoned professional,
                                        possessing over more than four decades of
                                        experience in the Indian Stock Market as well
                                        as Financial Markets.</Typography>

                                </Grid2> */}
                        <Grid2
                            className={`${LeaderWebViewStyles.flip_card} ${isFlipped ? LeaderWebViewStyles.is_flipped : ''}`}
                            onTouchStart={() => setIsFlipped(!isFlipped)}
                        >
                        <Grid2 className={LeaderWebViewStyles.flip_card}>
                            <Grid2 className={LeaderWebViewStyles.flip_card_inner}>
                                {/* Front Side */}
                                <Grid2 className={LeaderWebViewStyles.flip_card_front}>
                                    <img src={Narayana} alt="leaderpic" className={LeaderWebViewStyles.picture} />
                                        <Typography className={LeaderWebViewStyles.ex_subtit}>{t.founders[0].name}</Typography>
                                        <Typography className={LeaderWebViewStyles.ex_subtit1}>{t.founders[0].designation}</Typography>
                                </Grid2>
                                {/* Back Side */}
                                    <Grid2 className={LeaderWebViewStyles.flip_card_back1} >
                                        <div className={LeaderWebViewStyles.flip_back_content} ref={backRef} tabIndex={0} role="region" aria-label={`Founders profile details`}>
                                        <Typography className={LeaderWebViewStyles.ex_subtitback}>{t.founders[0].name}</Typography>
                                        <Typography className={LeaderWebViewStyles.ex_subtit1back}>{t.founders[0].designation}</Typography>
                                    <Typography className={LeaderWebViewStyles.ex_subtit2}>
                                            <span className={LeaderWebViewStyles.span} style={{ fontWeight: 600 }}>{t.founders[0].name1}</span>{t.founders[0].description}
                                    </Typography>
                                        </div>
                                </Grid2>
                            </Grid2>
                        </Grid2>
                        </Grid2>

                        <Grid2
                            className={`${LeaderWebViewStyles.flip_card} ${isFlipped2 ? LeaderWebViewStyles.is_flipped : ''}`}
                            onTouchStart={() => setIsFlipped2(!isFlipped2)}
                        >

                        <Grid2 className={LeaderWebViewStyles.flip_card} sx={{marginTop:"42px"}}>
                            <Grid2 className={LeaderWebViewStyles.flip_card_inner}>
                                {/* Front Side */}
                                <Grid2 className={LeaderWebViewStyles.flip_card_front}>
                                    <img src={Manaorama} alt="leaderpic" className={LeaderWebViewStyles.picture} />
                                        <Typography className={LeaderWebViewStyles.ex_subtit}>{t.founders[1].name}</Typography>
                                        <Typography className={LeaderWebViewStyles.ex_subtit1}>{t.founders[1].designation}</Typography>
                                </Grid2>
                                {/* Back Side */}
                                <Grid2 className={LeaderWebViewStyles.flip_card_back}>
                                        <Typography className={LeaderWebViewStyles.ex_subtitback}>{t.founders[1].name}</Typography>
                                        <Typography className={LeaderWebViewStyles.ex_subtit1back}>{t.founders[1].designation}</Typography>
                                    <Typography className={LeaderWebViewStyles.ex_subtit2}>
                                            <span className={LeaderWebViewStyles.span} style={{ fontWeight: 600 }}>{t.founders[1].name}</span>{t.founders[1].description}
                                    </Typography>
                                </Grid2>
                            </Grid2>
                        </Grid2>

                        </Grid2>

                        <Grid2
                            className={`${LeaderWebViewStyles.flip_card} ${isFlipped3 ? LeaderWebViewStyles.is_flipped : ''}`}
                            onTouchStart={() => setIsFlipped3(!isFlipped3)}
                            sx={{ marginTop: "82px" }}
                        >
                        <Grid2 className={LeaderWebViewStyles.flip_card} >
                            <Grid2 className={LeaderWebViewStyles.flip_card_inner}>
                                {/* Front Side */}
                                <Grid2 className={LeaderWebViewStyles.flip_card_front}>
                                    <img src={Roshni} alt="leaderpic" className={LeaderWebViewStyles.picture} />
                                        <Typography className={LeaderWebViewStyles.ex_subtit}>{t.founders[2].name}</Typography>
                                        <Typography className={LeaderWebViewStyles.ex_subtit1}>{t.founders[2].designation}</Typography>
                                </Grid2>
                                {/* Back Side */}
                                <Grid2 className={LeaderWebViewStyles.flip_card_back}>
                                        <Typography className={LeaderWebViewStyles.ex_subtitback}>{t.founders[2].name}</Typography>
                                        <Typography className={LeaderWebViewStyles.ex_subtit1back}>{t.founders[2].designation}</Typography>
                                    <Typography className={LeaderWebViewStyles.ex_subtit2}>
                                            <span className={LeaderWebViewStyles.span} style={{ fontWeight: 600 }}>{t.founders[2].name}</span>{t.founders[2].description}
                                    </Typography>
                                </Grid2>
                            </Grid2>
                        </Grid2>
                       </Grid2>

                            </Grid2>

                </Grid2>
      </Box>
    </>
    )
}